function ProcenaRizika() {
  return <>PROCENA RIZIKA</>;
}

export default ProcenaRizika;
